export default __webpack_public_path__ + "static/media/saving.a4b94b9f.jpg";